<template>
    <v-header />
    <router-view :key="$route.fullPath"/>
</template>
<script src="./Category.js"></script>
<style lang="scss" src="./Category.scss" scoped></style>
